/** @prettier */
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { changeProduct, setAppLoaded } from '@xanadu/ui-shared/modules/application/actions';

import { setTourMode } from '../../modules/customerOnboarding/actions';

import App from '../../components/App';

const mapDispatchToProps = {
  changeProduct,
  setTourMode,
  setAppLoaded,
};

function mapStateToProps(state) {
  return {
    navigationCollapsed: state.getIn(['navigation', 'navigationCollapsed']),
    navigationVisible: state.getIn(['navigation', 'navigationVisible']),
    bannerHeight: state.getIn(['application', 'bannerHeight']),
    uiVersion: state.getIn(['application', 'uiVersion']),
    betslipPinned: state.getIn(['betslip', 'betslipPinned']),
    rightSidebarVisible: state.getIn(['rightSidebar', 'visible']),
    windowWidthSize: state.getIn(['application', 'widthSize'], 0),
    eventId: state.getIn(['application', 'eventId']),
    product: state.getIn(['application', 'product']),
    inlineBetslipID: state.getIn(['inlineBetslip', 'inlineBetslipID']),
    customerOnboardingPopupVisible: state.getIn([
      'customerOnboarding',
      'customerOnboardingPopupConfig',
      'visible',
    ]),
    sidebarContent: state.getIn(['rightSidebar', 'content']),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
